import styled, { css } from "styled-components";

const ChangePasswordWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: 260px;
	border-radius: 20px;
	background: var(--profile-page-wrapper-bg);
	padding: 15px 10px;
	gap: 10px;

	.ant-form {
		display: flex;
		flex-direction: column;
		gap: 10px;
		width: 100%;
	}

	.ant-form-item {
		margin-bottom: 0;
	}

	.ant-form-item-explain {
		margin-left: 20px;
		margin-top: 5px;
	}

	.ant-input-affix-wrapper {
		width: 100%;
		padding: 0 10px 0 0 !important;
		border-radius: 50px;
	}

	.ant-form-item {
		margin-bottom: 0px;
		position: relative;
	}

	.change-password-button {
		border-radius: 25px;
		display: flex;
		height: 40px;
		width: 100%;
		justify-content: center;
		align-items: center;
		align-self: stretch;
		color: #fff;
		text-align: center;
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;

		${window.HAS_LESS_BORDER_RADIUS &&
		css`
			border-radius: 10px;
		`}

		background: var(--sign-in-btn-bg);
		color: var(--button-color);
		opacity: 0.6;

		svg {
			path {
				fill: var(--button-color);
			}
		}
	}

	.ant-btn-primary[disabled],
	.ant-btn-primary[disabled]:hover,
	.ant-btn-primary[disabled]:focus,
	.ant-btn-primary[disabled]:active {
		background: var(--sign-in-btn-bg);
		color: var(--button-color);
		opacity: 0.2;
	}
`;

const ChangePasswordHeader = styled.div`
	color: var(--main-explosive);
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
`;

export { ChangePasswordHeader, ChangePasswordWrapper };
